// extracted by mini-css-extract-plugin
export default {"container":"ExceptionConfig_container__qukub"};